import * as React from 'react';
import { Api } from '../api';
import { ScreenError, SoloLoading } from '../components';
import { useAuthRoles } from '../hooks';
import { isNetworkError } from '../util';

const UserStatusContext = React.createContext<{
  myClinicianStatus: Api.MyClinicianStatus.V;
  hasEditAccess: boolean;
}>({
  // @ts-expect-error - children not rendered until api request is complete
  myClinicianStatus: undefined,
  hasEditAccess: false,
});

type Props = {
  children: React.ReactNode;
};

export function UserStatusContextProvider({ children }: Props) {
  const { admin } = useAuthRoles();
  const apiClinicianStatus = Api.MyClinicianStatus.useReadItem({
    invalidateAge: 3 * 60,
    staleWhileInvalidated: true,
    staleWhileError: true,
  });

  if (
    apiClinicianStatus.error &&
    !(isNetworkError(apiClinicianStatus.error) && apiClinicianStatus.data)
  )
    return <ScreenError {...apiClinicianStatus} />;
  if (!apiClinicianStatus.data) return <SoloLoading />;

  const myClinicianStatus = apiClinicianStatus.data;

  return (
    <UserStatusContext.Provider
      value={{
        myClinicianStatus,
        hasEditAccess: admin
          ? true
          : (myClinicianStatus.user.clinicianProfile?.hasEditAccess ?? false),
      }}
    >
      {children}
    </UserStatusContext.Provider>
  );
}

export function useUserStatusContext() {
  return React.useContext(UserStatusContext);
}
